import moment from "moment";

//This file contains default values for the Engagment sectino

//Date Registered
//minDate for the DatePicker.  Currently Prod/Design wants it at 01/01/2010
//export const minDate = moment("01/01/2010").format("MM-DD-YYYY");
const minDate = "01/01/2010";

//maxDate is today.  Prod/Design wants all future dates to be inaccessible
const maxDate = moment().format("MM/DD/YYYY");

//defaultStartDate. Prod/Design wants 3 days from yesterday, which is also the defaultEndDate

const yesterday = moment().subtract(1, "day");
const defaultEndDate = yesterday.format("MM/DD/YYYY");
const defaultStartDate = yesterday.subtract(2, "day").format("MM/DD/YYYY");

export const EngagementDefaultDates = {
  minDate,
  maxDate,
  defaultEndDate,
  defaultStartDate
};
